module.exports = __webpack_public_path__ + "img/web-p2-t3.ab5f11bb.svg";